'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { CourseModule } from '~/payload-types';
export default function CourseNavigation(t0) {
  const $ = _c(16);
  const {
    modules,
    courseHrefPrefix,
    currentModuleIds
  } = t0;
  const pathname = usePathname();
  const [activeHash, setActiveHash] = useState("");
  let t1;
  if ($[0] !== currentModuleIds) {
    t1 = new Set(currentModuleIds);
    $[0] = currentModuleIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentModuleIdSet = t1;
  let t2;
  if ($[2] !== pathname) {
    t2 = pathname.includes("/module/");
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isOverviewPage = !t2;
  let t3;
  let t4;
  if ($[4] !== isOverviewPage) {
    t3 = () => {
      if (!isOverviewPage) {
        return;
      }
      const handleHashChange = () => {
        setActiveHash(window.location.hash);
      };
      handleHashChange();
      window.addEventListener("hashchange", handleHashChange);
      return () => window.removeEventListener("hashchange", handleHashChange);
    };
    t4 = [isOverviewPage];
    $[4] = isOverviewPage;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== activeHash || $[8] !== courseHrefPrefix || $[9] !== currentModuleIdSet || $[10] !== isOverviewPage || $[11] !== modules || $[12] !== pathname) {
    t5 = modules && modules.length > 0 && modules.map(module => {
      const moduleHref = `${courseHrefPrefix}#module-${module.id}`;
      const isCurrentModule = currentModuleIdSet.has(module.id);
      let isModuleActive = false;
      if (isOverviewPage) {
        isModuleActive = activeHash === `#module-${module.id}`;
      } else {
        isModuleActive = pathname.includes(`/module/${module.id}/`);
      }
      return <div key={module.id} className="relative pl-4 text-sm">{isCurrentModule && <span className="absolute left-0 top-0.5 text-sm text-primary-100 animate-pulse">▶</span>}{courseHrefPrefix ? <Link href={moduleHref} className={`transition-colors hover:text-primary-80 ${isModuleActive ? "font-bold text-primary-100" : "font-semibold text-gray-900"}`}>{module.title}</Link> : <a href={moduleHref} className={`transition-colors hover:text-primary-80 ${isModuleActive ? "font-bold text-primary-100" : "font-semibold text-gray-900"}`}>{module.title}</a>}{module.units && module.units.length > 0 && <div className="flex flex-col gap-1.5 mt-1 ml-4">{module.units.map(unit => {
            if (typeof unit === "number") {
              return null;
            }
            const unitHref = `${courseHrefPrefix}#unit-${unit.id}`;
            let isActive;
            if (isOverviewPage) {
              isActive = activeHash === `#unit-${unit.id}`;
            } else {
              const isUnitActive = pathname.includes(`/unit/${unit.id}/`);
              isActive = isModuleActive && isUnitActive;
            }
            return <div key={unit.id} className="relative">{courseHrefPrefix ? <Link href={unitHref} className={`transition-all duration-200 hover:text-primary-80 ${isActive ? "font-bold text-primary-100" : "text-gray-700"}`}>{` ${unit.title}`}</Link> : <a href={unitHref} className={`transition-all duration-200 hover:text-primary-80 ${isActive ? "font-bold text-primary-100" : "text-gray-700"}`}>{` ${unit.title}`}</a>}</div>;
          })}</div>}</div>;
    });
    $[7] = activeHash;
    $[8] = courseHrefPrefix;
    $[9] = currentModuleIdSet;
    $[10] = isOverviewPage;
    $[11] = modules;
    $[12] = pathname;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <div className="space-y-6">{t5}</div>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}